import {
  IGroupBy,
  useInfiniteQueryUserLibraryEntities,
  useQueryUserLibraryEntities,
  useQueryUserLibraryTrainers,
} from '@ifit/gateway-wolf-athenaeum-service';
import { useInfiniteQueryOptions, useRowQueryOptions } from '../query-options';
import getNextPageParam from '../get-next-page';
import { PAGE_SIZE } from '../../library';
import { useInfiniteQueryDataMemo } from '../query-memo';
import { useFeatureFlags } from '../../../helpers/good-cop-helper';
import { useEquipmentType } from '../equipment-type';
import { useModality } from '../use-modality';
const featureFlag = 'featureflag://flag?key=challenge-store&type=bool';
const useQueryRowParams = params => ({
  ...useRowQueryOptions(),
  useBasicAuth: true,
  overrides: undefined,
  ...params,
});

export const useEntitiesRowQuery = (params, options = null) => {
  const featureFlags = useFeatureFlags([featureFlag]);
  const doEnableChallengeStore = featureFlags[featureFlag]
    ? (featureFlags[featureFlag] as boolean)
    : false;
  return useQueryUserLibraryEntities(
    useQueryRowParams({ ...params, doEnableChallengeStore }),
    options,
  );
};

export const useEntitiesInfiniteQuery = (params, options = null) => {
  const featureFlags = useFeatureFlags([featureFlag]);
  const doEnableChallengeStore = featureFlags[featureFlag]
    ? (featureFlags[featureFlag] as boolean)
    : false;
  const { equipmentType, isLoading } = useEquipmentType();
  const modality = useModality(equipmentType);
  const enabled = !isLoading;

  return useInfiniteQueryDataMemo(
    useInfiniteQueryUserLibraryEntities(
      {
        ...useInfiniteQueryOptions(),
        ...params,
        useBasicAuth: params?.hasCompleted === undefined,
        useGatewayCache: params?.hasCompleted === undefined,
        doEnableChallengeStore,
        modality,
        perPage: PAGE_SIZE,
      },
      {
        getNextPageParam,
        ...options,
        enabled,
      },
    ),
  );
};

export const useGetCategoryRowsQuery = ({
  category,
  freeOnly = false,
}: {
  category?: string;
  freeOnly?: boolean;
}) => {
  const { equipmentType } = useEquipmentType();
  const featureFlags = useFeatureFlags(['featureflag://active-pulse']);
  const activePulse = featureFlags['featureflag://active-pulse'] as string;
  const params = {
    includedEntities: ['workout'],
    freeOnly,
    groupBy: category ? IGroupBy.Subcategory : IGroupBy.Category,
    activePulse: equipmentType
      ? activePulse?.includes(equipmentType.toLowerCase())
      : false,
    ...(category && { categories: [{ name: category }] }),
  };
  return useEntitiesRowQuery(params);
};

export const useTrainersRowQuery = (params, options = null) =>
  useQueryUserLibraryTrainers(useQueryRowParams(params), options);
